import { toSnakeCase } from './string'

export const MODULE_ID_SEPARATOR = '::'
export const MODULE_VARIANT_SEPARATOR = '--'
export const FIRST_MODULE_ID = '@@TOP'

export const toSiblingMap = (siblingSelectors = []) =>
  siblingSelectors.reduce((acc, it) => {
    const keyArr = it.key.map((i) => {
      if (typeof i === 'string') {
        return i
      }
      const { module, variant, layout } = i
      return [module, toSnakeCase(variant || layout)].filter(Boolean).join(MODULE_VARIANT_SEPARATOR)
    })
    return { ...acc, [keyArr.join(MODULE_ID_SEPARATOR)]: it }
  }, {})

/* eslint-disable-next-line */
export const __example__devModuleIds = ['palette', 'spacingOverride']
